import "./Loader.css";
import React, { createContext, useContext, useMemo, useState } from "react";
import { TailSpin } from "react-loader-spinner";
import Modal from "react-bootstrap/Modal";
const LoaderContext = createContext({
  show: () => {},
  hide: () => {},
});

interface LoaderType {
  children?: React.JSX.Element | React.JSX.Element[];
}

interface HookFun {
  show: () => void;
  hide: () => void;
}

export const useLoader = (): HookFun => useContext(LoaderContext);
function LoaderProvider({ children }: LoaderType) {
  const [show, setShow] = useState(false);
  const value = useMemo(() => {
    return {
      show: () => setShow(true),
      hide: () => setShow(false),
    };
  }, []);
  return (
    <LoaderContext.Provider value={value}>
      {children}
      <Modal
        backdrop="static"
        keyboard={false}
        centered
        style={{ zIndex: 20001}}
        backdropClassName="loader-backdrop"
        contentClassName="loader-content"
        show={show}
      >
        <div className="loader-container">
          <TailSpin // Type of spinner
            height="100"
            width="100"
            color="#007bff"
            ariaLabel="tail-spin-loading"
            radius="1"
            wrapperStyle={{}}
            wrapperClass=""
            visible={true}
          />
        </div>
      </Modal>
    </LoaderContext.Provider>
  );
}

export default LoaderProvider;
